//Sub permission: check \App\Lib\AdminPermissions.php
import routerConfigs from '../router-configs/tsRouterConfigs'

export default [
  {
    title: 'Top Surveys',
    icon: 'AwardIcon',
    children: [
      {
        url: routerConfigs.TS_ADJUST_EVENT_LOGS.path,
        title: 'Adjust Event Logs',
        icon: 'FileTextIcon',
        route: routerConfigs.TS_ADJUST_EVENT_LOGS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_ADJUST_EVENT_LOGS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_AFFILIATE_PARTNERS.path,
        title: 'Affiliate Partners',
        icon: 'UserPlusIcon',
        route: routerConfigs.TS_AFFILIATE_PARTNERS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_AFFILIATE_PARTNERS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_BONUS_CODES.path,
        title: 'Bonus Codes',
        icon: 'GiftIcon',
        route: routerConfigs.TS_BONUS_CODES.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_BONUS_CODES.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_BONUS_CODE_REDEMPTIONS.path,
        title: 'Bonus Code Redemptions',
        icon: 'DollarSignIcon',
        route: routerConfigs.TS_BONUS_CODE_REDEMPTIONS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_BONUS_CODE_REDEMPTIONS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_LOG_SPEND.path,
        title: 'Log Spend',
        icon: 'DollarSignIcon',
        route: routerConfigs.TS_LOG_SPEND.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_LOG_SPEND.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_USERS.path,
        title: 'Users',
        icon: 'UsersIcon',
        route: routerConfigs.TS_USERS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_USERS.name,
            text: 'Main',
            main: true
          },
          {
            id: 'ts_users_export',
            text: 'TS Users Export',
            always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 9]
          },
          {
            id: 'ts_users_delete',
            text: 'TS Users Delete',
            always_available_for_ids: window.CONST_TOP_ADMIN_IDS
          }
        ]
      },
      {
        url: routerConfigs.TS_USER_REWARD_ELIGIBILITY_LOGS.path,
        title: 'User Reward Eligibility Logs',
        icon: 'FileTextIcon',
        route: routerConfigs.TS_USER_REWARD_ELIGIBILITY_LOGS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_USER_REWARD_ELIGIBILITY_LOGS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        title: 'TS User details',
        hidden: true,
        sub_permissions: [
          {
            id: routerConfigs.TS_USER_DETAILS.name,
            text: 'Main',
            main: true
          },
          {
            id: 'ts_user_credit',
            text: 'TS User Credit',
            always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 26, 32, 50, 93]
          },
          {
            id: 'ts_overwrite_eligible',
            text: 'TS Overwrite Eligible',
            always_available_for_ids: window.CONST_TOP_ADMIN_IDS
          }
        ]
      },
      {
        url: routerConfigs.TS_TRANSACTIONS.path,
        title: 'Transactions',
        icon: 'DatabaseIcon',
        route: routerConfigs.TS_TRANSACTIONS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_TRANSACTIONS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_CLAIMS.path,
        title: 'Claims',
        icon: 'CheckSquareIcon',
        route: routerConfigs.TS_CLAIMS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_CLAIMS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_COHORT_ANALYSIS.path,
        title: 'Cohort Analysis',
        icon: 'LayoutIcon',
        route: routerConfigs.TS_COHORT_ANALYSIS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_COHORT_ANALYSIS.name,
            text: 'Main',
            main: true
          },
          {
            id: 'ts_cohort_analysis_export',
            text: 'TS Cohort Analysis Export',
            always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 9]
          }
        ]
      },
      {
        url: routerConfigs.TS_SETTINGS.path,
        title: 'Settings',
        icon: 'SettingsIcon',
        route: routerConfigs.TS_SETTINGS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 6, 55],
        sub_permissions: [
          {
            id: routerConfigs.TS_SETTINGS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_FRONTEND_SETTINGS.path,
        title: 'Frontend Settings',
        icon: 'SlidersIcon',
        route: routerConfigs.TS_FRONTEND_SETTINGS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 6, 55],
        sub_permissions: [
          {
            id: routerConfigs.TS_FRONTEND_SETTINGS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_CAMPAIGN_SETTINGS.path,
        title: 'Campaign Settings',
        icon: 'TargetIcon',
        route: routerConfigs.TS_CAMPAIGN_SETTINGS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 6, 55],
        sub_permissions: [{ id: routerConfigs.TS_CAMPAIGN_SETTINGS.name, text: 'Main', main: true }]
      },
      {
        url: routerConfigs.TS_TUNE_REJECTION_SETTINGS.path,
        title: 'Tune Rejection Settings',
        icon: 'SettingsIcon',
        route: routerConfigs.TS_TUNE_REJECTION_SETTINGS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 6, 55],
        sub_permissions: [{ id: routerConfigs.TS_TUNE_REJECTION_SETTINGS.name, text: 'Main', main: true }]
      },
      {
        url: routerConfigs.TS_TUNE_REJECTIONS.path,
        title: 'Tune Rejections',
        icon: 'BarChart2Icon',
        route: routerConfigs.TS_TUNE_REJECTIONS.name,
        always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 6, 55],
        sub_permissions: [{ id: routerConfigs.TS_TUNE_REJECTIONS.name, text: 'Main', main: true }]
      },
      {
        url: routerConfigs.TS_TRIGGERS.path,
        title: 'Triggers',
        icon: 'DiscIcon',
        route: routerConfigs.TS_TRIGGERS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_TRIGGERS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_PERFORMANCE.path,
        title: 'Performance',
        icon: 'PieChartIcon',
        route: routerConfigs.TS_PERFORMANCE.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_PERFORMANCE.name,
            text: 'Main',
            main: true
          },
          {
            id: routerConfigs.TS_PERFORMANCE_EXPORT.name,
            text: 'TS Performance Export',
            always_available_for_ids: [...window.CONST_TOP_ADMIN_IDS, 9]
          }
        ]
      },
      {
        url: routerConfigs.TS_REWARDS.path,
        title: 'Rewards',
        icon: 'AwardIcon',
        route: routerConfigs.TS_REWARDS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_REWARDS.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_EMAILS.path,
        title: 'E-Mails',
        icon: 'MailIcon',
        route: routerConfigs.TS_EMAILS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_EMAILS.name,
            text: 'Main',
            main: true
          },
          {
            id: 'ts_emails_view_url',
            text: 'TS Emails View URL',
            always_available_for_ids: window.CONST_TOP_ADMIN_IDS
          }
        ]
      },
      {
        url: routerConfigs.TS_OFFER_WALL_PERFORMANCE.path,
        title: 'Offerwall Performance',
        icon: 'CpuIcon',
        route: routerConfigs.TS_OFFER_WALL_PERFORMANCE.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_OFFER_WALL_PERFORMANCE.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_ADJUST_CONFIG.path,
        title: 'Adjust Config',
        icon: 'CodesandboxIcon',
        route: routerConfigs.TS_ADJUST_CONFIG.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_ADJUST_CONFIG.name,
            text: 'Main',
            main: true
          }
        ]
      },
      {
        url: routerConfigs.TS_DYNAMIC_CAMPAIGNS.path,
        title: 'Dynamic Campaigns',
        icon: 'MailIcon',
        route: routerConfigs.TS_DYNAMIC_CAMPAIGNS.name,
        sub_permissions: [
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS.name,
            text: 'Main',
            main: true
          },
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS_EMAILS.name,
            text: 'Email Campaigns'
          },
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS_EMAILS_CREATE.name,
            text: 'Campaign Emails Create'
          },
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS_EMAILS_EDIT.name,
            text: 'Campaign Emails Edit'
          },
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT.name,
            text: 'Campaign Emails Translation Edit'
          },
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS.name,
            text: 'Push Notifications Campaigns'
          },
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE.name,
            text: 'Campaign Push Notifications Create'
          },
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT.name,
            text: 'Campaign Push Notifications Edit'
          },
          {
            id: routerConfigs.TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT.name,
            text: 'Campaign Push Notifications Translation Edit'
          }
        ]
      }
    ]
  }
]
